/**
  pop messageなどその他機能
*/
import webapi from '../../api/webapi'
import setting from '../../ms.config'

const state = {
  toastVisible: false,
  toastMessage: '',
  errorVisible: false,
  errorMessage: '',
  isScreenLoading: false,
  isResponseWaiting: false
}

const getters = {
  toastVisible: state => state.toastVisible,
  toastMessage: state => state.toastMessage,
  errorVisible: state => state.errorVisible,
  errorMessage: state => state.errorMessage,
  isScreenLoading: state => state.isScreenLoading,
  isResponseWaiting: state => state.isResponseWaiting
}

const actions = {
  /**
    サーバーからユーザー情報を取得する
  */
  sendErrorLog({ commit, dispatch, getters }, log) {
    return new Promise((resolve, reject) => {
      webapi
        .request(uri.SEND_ERROR_LOG, { text: log }, getters.currentLang, () =>
          dispatch('navigatePage', 'login')
        )
        .then(() => {
          resolve()
        })
        .catch(errors => {
          dispatch('showErrorMessage', errors)
          reject()
        })
    })
  },
  showLogMessage({ commit }, msg) {
    if(setting.ENV.mode=='dev'){
      const m = Array.isArray(msg) ? msg.join('<br/>') : msg
      commit('setToastMessage', m)
      commit('setToastVisible', true)
      setTimeout(() => {
        commit('setToastVisible', false)
      }, 6000)
    }
  },
  showMessage({ commit }, msg) {
    const m = Array.isArray(msg) ? msg.join('<br/>') : msg
    commit('setToastMessage', m)
    commit('setToastVisible', true)
    setTimeout(() => {
      commit('setToastVisible', false)
    }, 3000)
  },
  showErrorMessage({ commit }, error) {
    let msg = ''
    if (Array.isArray(error)) {
      error.forEach(item => {
        if (item.message) {
          msg += item.message + '<br/>'
        } else {
          msg += item + '<br/>'
        }
      })
    } else {
      msg = error
    }
    if (msg) {
      commit('setErrorMessage', msg)
      commit('setErrorVisible', true)
      setTimeout(() => {
        commit('setErrorVisible', false)
      }, 6000)
    }
  },
  setLoadingScreenVisibility({ commit }, visible) {
    commit('setLoadingScreenVisibility', visible)
  },
  setResponseWaiting({ commit }, visible) {
    commit('setWaiting', visible)
  },
  setToastVisible({ commit }, visible) {
    commit('setToastVisible', visible)
  },
  setErrorVisible({ commit }, visible) {
    commit('setErrorVisible', visible)
  }
}

const mutations = {
  setLoadingScreenVisibility(state, visible) {
    state.isScreenLoading = visible
  },
  setWaiting(state, visible) {
    state.isResponseWaiting = visible
  },
  setToastVisible(state, visible) {
    state.toastVisible = visible
    state.isResponseWaiting = false
    state.isScreenLoading = false
  },
  setToastMessage(state, msg) {
    state.toastMessage = msg
  },
  setErrorVisible(state, visible) {
    state.errorVisible = visible
    state.isResponseWaiting = false
    state.isScreenLoading = false
  },
  setErrorMessage(state, msg) {
    state.errorMessage = msg
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/misc.js